
import { getPlatform } from "@utils/platformDetection.client";
import { getCityFromIp } from "@utils/cityDetection";
import { getCustomerStatus } from "@utils/customerStatusManager";
import {
  LEAD_CAPTURE_TOKEN,
  LEAD_CAPTURE_CARS24_TOKEN,
  OLX_TOKEN,
  OLX_MAIN,
  OLX_CHAT,
  OLX_CHAT_TOKEN,
  OLX_CENTRE,
  OLX_CENTRE_TOKEN,
  ACKODRIVE_LP,
  ACKODRIVE_LP_TOKEN,
  SEM_LP,
  SEM_LP_TOKEN,
  LeadSourceType,
} from "@constants/leadCapture";
import { LEAD_CAPTURE_URL } from "./endpoints";
import {
  LeadCapturePayload,
  LeadCaptureResponse,
} from "@interfaces/leadCapture.types";

/**
 * Get the appropriate token based on lead source
 */
const getTokenForLeadSource = (leadSrc: LeadSourceType): string => {
  switch (leadSrc) {
    case "Cars 24":
      return LEAD_CAPTURE_CARS24_TOKEN;
    case OLX_MAIN:
      return OLX_TOKEN;
    case OLX_CHAT:
      return OLX_CHAT_TOKEN;
    case OLX_CENTRE:
      return OLX_CENTRE_TOKEN;
    case ACKODRIVE_LP:
      return ACKODRIVE_LP_TOKEN;
    case SEM_LP:
      return SEM_LP_TOKEN;
    default:
      return LEAD_CAPTURE_TOKEN;
  }
};

/**
 * Post lead data to the lead capture API
 */
export const postLead = async (
  payload: LeadCapturePayload,
  leadSrc?: LeadSourceType
): Promise<LeadCaptureResponse> => {
  const url = LEAD_CAPTURE_URL;
  const token = leadSrc ? getTokenForLeadSource(leadSrc) : LEAD_CAPTURE_TOKEN;
  const platform = getPlatform();

  try {
    // Get additional data
    const [ipCity, customerStatus] = await Promise.all([
      getCityFromIp(),
      getCustomerStatus(),
    ]);

    // Prepare final payload
    const finalPayload: any = {
      ...payload,
      platform,
      dump_data: {
        ...(payload.dump_data || {}),
        mx_Is_Active_Policy_Holder: customerStatus?.is_active_policy_holder,
        mx_Is_Acko_Customer: customerStatus?.is_acko_customer,
        mx1_ACKO_Active_Policies: customerStatus?.active_policies,
        mx_ACKO_Expired_Policies: customerStatus?.expired_policies,
        mx_ACKO_User: customerStatus?.acko_user,
        mx_ACKO_Vehicle_Number: customerStatus?.old_vehicle_numbers,
        mx_ACKO_Model: customerStatus?.car_details,
        mx_ACKO_Model_Registration_Year: customerStatus?.car_registration,
      },
    };

        // Add IP city data if available
    if (ipCity) {
      finalPayload.ip_city = ipCity;
    }

      // Make API request
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(finalPayload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return {
      success: true,
      data: data,
    };
  } catch (error) {
    console.error("Lead capture API error:", error);
    return {
      success: false,
      error: {
        message: error instanceof Error ? error.message : "Unknown error",
      },
    };
  }
}; 